/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { init, browserTracingIntegration } from '@sentry/angular';

init({
	dsn: environment.sentryDSN, // Null DSN will disable Sentry
	integrations: [browserTracingIntegration()],
	tracePropagationTargets: ['localhost', environment.apiUrl],
	environment: environment.env,
	tracesSampleRate: 1.0, // Set to 1.0 to capture 100% of transactions for monitoring, adjust in production as necessary
	beforeSend(event, hint) {
		// Custom modification for specific HTTP responses
		if (
			hint?.originalException instanceof HttpErrorResponse &&
			hint.originalException.status === 401
		) {
			return null; // Do not send events for HTTP 401 errors
		}
		return event;
	}
});

if (environment.production) {
	enableProdMode();
}

const preferredTheme =
	(localStorage.getItem('preferredTheme') as 'Dark' | 'Light') || 'Light';

if (preferredTheme === 'Dark') {
	document.body.classList.add('dark-theme');
} else {
	document.body.classList.add('light-theme');
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(() => {
		// @ts-ignore
		if (window.appBootstrap) {
			// @ts-ignore
			window.appBootstrap();
		}
	})
	// eslint-disable-next-line no-console
	.catch((err) => console.error(err));
